<template>
  <div>
    <div class="logo-header flex-btw-ctr">
      <div class="logo flex-ctr">
        <img  :src="user.portalLogo||require('@/assets/images/logo.png')" alt="logo" />
        <div>{{sysConfig.portalSysName}}</div>
      </div>
      <div class="user flex-ctr" @click="isOut=!isOut">
        <img class="userPhoto" :src="user.avatar||require('@/assets/images/user.png')" alt="">
        <div>
          <div  class="username">{{user.info.name}}</div>
          <div class="school overS">{{user.company}}</div>
        </div>
        <i class="el-icon-caret-bottom"></i>
        <div class="userBtnList" v-show="isOut">
          <div class="li" @click="logout">退出登录</div>
        </div>
      </div>
      
    </div>
    <div class="menu-bg">
      <div class="menu flex-btw-ctr">
        <div 
          v-for="item in menus"
          :key="item.path"
          :class="['menu-item', { 'active-menu':$route.path.includes(item.path)  }]"
          @click="toPage(item.path)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- <el-dialog title="" :visible.sync="visible" width="500px" :close-on-press-escape="false" :close-on-click-modal="false">
      <login-form ref="LoginForm" @login="visible = false"></login-form>
    </el-dialog> -->
    <div class="isOutBg" v-show="isOut" @click="isOut=false"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    activeIndex: {
      type: String,
      default: "/login",
    },
  },
  data () {
    return {
      isOut:false,
      menus: [
        { name: "首页", path: "/index" },
        { name: "我的培训班", path: "/myTrain" },
        { name: "网络自学", path: "/selfStudy" },
        { name: "我的测试", path: "/myTest" },
        { name: "学时统计", path: "/studyTime" },
        { name: "个人信息", path: "/userInfo" },
      ],
      visible: false,
      // h5Url: `${window.location.protocol}//${window.location.hostname}/h5`,
    };
  },
  computed: {
		...mapState(["isLogin", "user","sysConfig"]),
	},
  created(){
    if(this.sysConfig){
      document.title = this.sysConfig.adminSysName || '';
				var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				link.rel = 'icon';
				link.href = this.sysConfig.portalLogo && this.sysConfig.portalLogo.replace('http://', 'https://');
				document.getElementsByTagName('head')[0].appendChild(link);
    }
  },
  methods: {
    toPage (path, query) {
      this.$router.push({ path, query });
    },
    logout () {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // logout().then((res) => {
          //   this.$router.push('/login').catch(err => {
          //     if (err.name !== 'NavigationDuplicated') {
          //       throw err;
          //     }
          //   });
          //   this.$store.commit("LOGOUT");
          //   window.location.reload()
          // });
            this.$store.commit("LOGOUT");
            this.$router.push("/login");
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-header {
  width: 1200px;
  margin: auto;
  padding: 18px 0;

  .logo {
    font-weight: 700;
    font-size: 25px;
    color: #1A1A1A;

    img {
      width: 45px;
      height: 45px;
      margin-right: 17px;
    }
  }

  .user {
    cursor: pointer;
    position: relative;
    img {
      width: 36px;
      height: 36px;
      margin-right: 5px;
    }

    .username {
      margin-bottom: 4px;
      font-weight: 500;
      font-size: 14px;
      color: #1A1A1A;
      line-height: 14px;
    }

    .school {
      font-weight: 400;
      font-size: 14px;
      color: #767676;
      line-height: 14px;
    }
  }
}

.menu-bg {
  background: linear-gradient( 270deg, #E4381D 0%, #D81D10 100%);
  border-radius: 0px 0px 0px 0px;

  .menu {
    padding: 0 70px;
    margin: auto;
    width: 1200px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 54px;

    .menu-item {
      padding: 0 18px;
      text-align: center;
      cursor: pointer;
    }

    .active-menu {
      background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
      font-weight: 700;
    }
  }
}
.userPhoto{
    border-radius: 50%;
}
.overS{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 80px;
}
.userBtnList{
  position: absolute;
  right: 0;
  top: 50px;
  background: #FFFFFF;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
    word-break: break-all;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(235, 238, 245);
    border-image: initial;
    z-index: 99;
  width: 100px;
  .li{
    height: 40px;
    line-height: 40px;
    padding:0 15px;
    font-size: 14px;
    color: #767676;
  }
  .li:hover{
    color: rgb(64, 158, 255);
    background-color: rgb(236, 245, 255);
    border-color: rgb(198, 226, 255);
  }
}
.isOutBg{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
